export default {
    subtitle: "Information on Transactions (List, Details)",
    path: "transactions_generals",
    paragraphs: [
     "You can list all the transactions made; it will be ordered from the most recent ones. You can use some parameters to filter the transactions of this list, like customer, day and time, status, currency and others. To list transactions, you will use the following endpoint:",
     "Note that the API can return the maximum of 100 in this list.",
     "Example: You can use the endpoint '/transactions?last_id=a5c69e9e-8d84-4b0b-9af8-dcfb5be35093&per_page=1'.",
     "This will return the last transaction after the transaction with ID a5c69e9e-8d84-4b0b-9af8-dcfb5be35093.",
    ],
    request: {
      method: "GET", 
      endpoint: "/transactions",
      responses: {
      "data": [
          {
              "value": "1250.00",
              "to_bank_account_id": "c3d8b7e8-4022-4ce6-9d45-c4666ea53653",
              "subject_is_receiver": true,
              "subject_id": "01e0725b-b4f5-46b1-811a-a3cbcb314d10",
              "status": "identified",
              "source_name": "John Doe",
              "source_document_type": "cpf",
              "source_document_number": "05069869183",
              "meta": null,
              "inserted_at": "2025-07-09T19:25:27.114588",
              "id": "4835d070-2042-4e95-8771-48fd46d6fa6b",
              "from_credit_card": null,
              "from_bank_account_id": "a2474d90-eca9-47ac-90f2-0487d51b4bef",
              "for_exchange": true,
              "exchanged_value": "7280.90",
              "exchange_under_request": true,
              "exchange_currency": "BRL",
              "estimated_value_until_exchange": false,
              "currency": "USD",
              "cleared": true,
              "bank_transaction": {
                  "wire_id": null,
                  "value": "1250",
                  "spei_reference": null,
                  "spei_concepto_de_pago": null,
                  "source_type": "WIRE",
                  "source_name": "John Doe",
                  "source_id": null,
                  "source_document_type": "cpf",
                  "source_document_number": "05069869183",
                  "source_description": "CREDITO POR TED",
                  "source_branch": "1142",
                  "source_bank_ispb": null,
                  "source_bank": "033",
                  "source_account": "130013844",
                  "movement_date": "2025-07-09",
                  "iof_value": "28.05",
                  "inserted_at": "2025-07-09T19:27:07.077907",
                  "id": "7c7203c8-a1e3-4a7d-996f-600e80939c02",
                  "exchanged_value": "7280.90",
                  "exchange_rate_spot": "5.90600000",
                  "exchange_rate": "5.82472",
                  "exchange_id": "dd5e4988-66b3-457d-8024-fc3f094bb1fc",
                  "exchange_currency": "BRL",
                  "exchange_approved": false,
                  "currency": "USD"
              }
          }
      ]
  }
    },
    queryPayload: [
      {
        name: "last_id",
        type: "string",
        required: false,
        description: "Last transaction UUID for pagination"
      },
      {
        name: "per_page",
        type: "string",
        required: false,
        description: "Number of elements per page"
      },
      {
        name: "id",
        type: "string",
        required: false,
        description: "Transaction UUID"
      },
      {
        name: "status",
        type: "string",
        required: false,
        description: "Filter only transaction based on status"
      },
      {
        name: "from",
        type: "iso datetime",
        required: false,
        description: "Filter from date/time, e.g.: 2022-05-01T03%3A00%3A00.000Z"
      },
      {
        name: "to",
        type: "iso datetime",
        required: false,
        description: "Filter to date/time, e.g.: 2022-05-30T03%3A00%3A00.000Z"
      },
      {
        name: "currency",
        type: "string",
        required: false,
        description: "Filter to match only the selected currency"
      },
      {
        name: "exchange_currency",
        type: "string",
        required: false,
        description: "Filter to match only the selected currency as exchanged"
      },
      {
        name: "subject_id",
        type: "string",
        required: false,
        description: "subject_id used in the transactions"
      }
    ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionsGenerals.js